const setDocumentTitle = (title: string) => {
  document.title = title + " | MarketPlaceIQ";
}

export default setDocumentTitle;